import { cdnUrl } from "client/config/url";

export const ColorPickerRainBowIcon = () => {
    return <img src={`${cdnUrl}/icons/color-picker-rainbow-icon.png`} width={24} height={24} />;
};
